/**
 * Renders an individual club icon in the top club hero in the home page
 */
import React from "react";
import { Link } from "react-router-dom";

const HomeClubIndividual = ({ id, name, logo }) => {
  return (
    <Link to={"/club/" + id} className="mx-1.5">
      <img
        className="icons2:h-10 icons2:w-10 h-8 w-8 hidden icons1:block --- transition-transform duration-200 ease-in-out transform hover:scale-110"
        src={logo}
        alt={name}
      />
    </Link>
  );
};

export default HomeClubIndividual;
